module.exports = __webpack_public_path__ + "img/soccer.cbd92010.svg";